import DropdownProfile from '../../../profile/view/DropdownProfile.react';
import PosConstants from '../../../../constants/PosConstants';
import PropTypes from 'prop-types';
import UserStore from '../../../../stores/UserStore';

class LinxCheckout extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            CardNumber: '',
            DriversLicenseNumber: '',
            CustomerState: '',
        };

        this.getErrors = this.getErrors.bind(this);
        this.doCheckout = this.doCheckout.bind(this);
        this.readCardSwipe = this.readCardSwipe.bind(this);
        this.parseSwipe = this.parseSwipe.bind(this);

        this.scannedValues = [];
    }

    componentDidMount() {
        var driver_license_id = '';
        for (var i=0; i<this.props.guest.identifications.length; i++) {
            if (this.props.guest.identifications[i].type === 'DriversLicenseId') {
                driver_license_id = this.props.guest.identifications[i].number;
            }
        }

        this.setState({
            DriversLicenseNumber: driver_license_id,
            CustomerState:  this.props.guest.address.state,
        });
        this.scannedValues = [];
        document.addEventListener('keydown', this.readCardSwipe);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.readCardSwipe);
    }

    readCardSwipe(event) {
        if((event.which >= 32)) {
            this.scannedValues.push(event.key);
        }
        if(event.which === 13) {
            this.scannedValues.push('\n');
        }
        
        if(this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(this.parseSwipe, 100);
    }

    parseSwipe() {
        var swipe = this.scannedValues.join('');
        this.scannedValues = [];
        var CardNumber = swipe.substr(swipe.indexOf(';')+1, 16);
        this.setState({ CardNumber })
    }

    getErrors() {
        if(!this.state.CardNumber) {
            return 'Card Number required';
        }

        if(!this.state.DriversLicenseNumber) {
            return 'Drivers license number required';
        }

        if(!this.state.CustomerState) {
            return 'State required';
        }

        
        return false;
    }

    doCheckout() {
        if(this.getErrors()) {
            return;
        }

        let data = Object.assign({}, this.state);
        data.Budtender = UserStore.getState().user.FullName;
        this.props.onComplete(data);
    }

    render() {
        return (
            <div className='checkout-completed'>
                <div className='checkout-completed__title' style={{height: 40, lineHeight: '40px'}}>
                    Linx Card Number
                </div>
                <div>
                    <div className="checkout-input">
                        <input
                            style={{
                                position: 'absolute', top: 0, left: -60, width: 260,
                            }}
                            type="text"
                            value={this.state.CardNumber}
                            onChange={e => this.setState({ CardNumber: e.target.value })}
                        />
                    </div>
                    
                </div>

                <div className='checkout-completed__title' style={{height: 40, lineHeight: '40px'}}>
                    Drivers License Number
                </div>
                <div>
                    <div className="checkout-input">
                        <input
                            style={{
                                position: 'absolute', top: 0, left: -60, width: 260,
                            }}
                            type="text"
                            value={this.state.DriversLicenseNumber}
                            onChange={e => this.setState({ DriversLicenseNumber: e.target.value })}
                        />
                    </div>
                    
                </div>

                <div className='checkout-completed__title' style={{height: 40, lineHeight: '40px'}}>
                    Drivers License State
                </div>
                <div className="checkout-input">

                    <select
                    value={this.state.CustomerState}
                    style={{
                        position: 'absolute', top: 10, left: -60, width: 260, fontSize: 20,
                    }}
                    selected={this.state.CustomerState}
                    onChange={e => this.setState({ CustomerState: e.target.value })}>
                    {
                        PosConstants.States.map((data, i) => {
                            return (
                                <option
                                    value={data.option}
                                    key={'data.title'+i}>
    
                                    {data.title}
                                </option>
                            );
                        })
                    }
                    </select>
                    
                </div>
                <div> 
                </div>
                <div className='row' style={{margin:0}}>
                    
                    <div
                        style={{
                            display: 'block', left: 40, width: 120, margin: '0 auto', marginBottom: 10, marginTop: 10,
                        }}
                        className={'btn-red'}
                        onClick={this.props.onCancel}>
                        Cancel
                    </div>
                    <div
                        style={{
                            display: 'block', right: 40, width: 120, margin: '0 auto', marginBottom: 10, marginTop: 10,
                        }}
                        className={'btn-green ' + (this.getErrors() ? 'btn-green__disabled' : '')}
                        onClick={this.doCheckout}>
                        CHECKOUT
                    </div>
                </div>
            </div>
        );
    }
}
LinxCheckout.propTypes = {
    guest: PropTypes.any.isRequired,

    onCancel: PropTypes.func.isRequired,
};

export default LinxCheckout;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/electronic/LinxCheckout.react.jsx